export let mimeTypes = {
    'pdf' : 'pdf',
    'doc' : 'msword',
    'docx' : 'msword',
    'xls' : 'vnd.ms-excel',
    'xlsx' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}